/**
 * 合作方式。
 *
 * 放在「关于」之后、「联系」之前：先讲清楚怎么合作、拿到什么、什么情况下我会说不，
 * 再让人来找。阳仔AI接活，客户最担心的三件事是「会不会烂尾」「会不会加价」
 * 「人跑了怎么办」——这一段就是逐条回答它们，所以每步都写明交付物，
 * 而不是四个动词配四个图标。
 *
 * 「不接什么」那一栏是故意留的：能说清楚边界的人，比什么都接的人可信。
 */

const steps: [string, string, string, string][] = [
  [
    '01',
    '先把事情说清楚',
    '一次对话，把场景、约束、预算和时间讲到能判断的程度。我给的第一个回答是「能不能做、值不值得做」——包括「这个需求不值得做」。',
    '一份判断，不收钱',
  ],
  [
    '02',
    '方案与固定报价',
    '技术方案、里程碑拆分、固定报价、验收标准，一次给全。范围之内不加价；范围要变，先改方案再谈钱。',
    '方案书 + 报价 + 验收标准',
  ],
  [
    '03',
    '分阶段交付',
    '每个里程碑交的是能跑起来的东西，不是文档和进度条。你随时可以喊停——停在哪一段，那一段的成果就归你。',
    '每阶段一个可运行版本',
  ],
  [
    '04',
    '上线之后',
    '源码、部署脚本、运维说明一并交付，附一段保修期。之后你可以让自己的团队接着做，也可以继续找我。',
    '源码 + 部署交付 + 保修期',
  ],
];

const declines = [
  '只有一句「做个 AI」、说不出场景和判定标准的需求',
  '要求承诺收益、代客理财，或者把量化包装成理财产品',
  '需要绕过平台规则、爬取隐私数据或伪造数据的活',
  '排期上确实接不下的——同时开三条线，并行接单有上限，接不了我会直接说',
];

export default function CollabSection() {
  return (
    <section
      id="collab"
      className="border-t border-rack-bone/[0.08] bg-rack-ground py-20 sm:py-28"
      aria-labelledby="collab-title"
    >
      <div className="mx-auto max-w-[1180px] px-6 sm:px-10">
        <div className="flex flex-wrap items-baseline gap-x-5 gap-y-2">
          <span className="font-readout text-[11px] tracking-[0.22em] text-rack-bone/30">
            COLLABORATION
          </span>
          <h2
            id="collab-title"
            className="font-songti text-[clamp(1.5rem,4vw,2.15rem)] font-semibold tracking-[0.14em] text-rack-bone"
          >
            合作方式
          </h2>
        </div>

        <p className="mt-7 max-w-[30ch] font-songti text-[clamp(1.15rem,2.9vw,1.6rem)] font-semibold leading-[1.5] tracking-[0.08em] text-rack-bone/92">
          先说清楚，再动手
        </p>
        <p className="mt-5 max-w-[62ch] text-[13.5px] leading-[1.95] text-rack-bone/50">
          阳仔AI接活，客户最担心的是烂尾、加价和人跑了。下面四步和最后那一栏，就是逐条回答这三件事。
        </p>

        {/* 四步。沿用 datasheet：编号 / 说明 / 你拿到什么 */}
        <div className="mt-12 border-t border-rack-bone/12">
          {steps.map(([no, title, detail, out]) => (
            <article
              key={no}
              className="grid gap-x-7 gap-y-3 border-b border-rack-bone/[0.07] py-7 md:grid-cols-[44px_1fr_196px]"
            >
              <div className="flex items-start gap-2.5">
                <span className="mt-[7px] h-px w-2.5 shrink-0 bg-rack-amber" />
                <span className="font-readout text-[11px] text-rack-bone/30">{no}</span>
              </div>
              <div>
                <h3 className="text-[15px] font-medium leading-snug text-rack-bone/92">{title}</h3>
                <p className="mt-2.5 max-w-[58ch] text-[13px] leading-[1.95] text-rack-bone/48">
                  {detail}
                </p>
              </div>
              <div>
                <span className="font-readout text-[9.5px] uppercase tracking-[0.16em] text-rack-bone/26">
                  你拿到
                </span>
                <p className="mt-1.5 text-[12.5px] leading-[1.7] text-rack-bone/72">{out}</p>
              </div>
            </article>
          ))}
        </div>

        {/* 边界 */}
        <div className="mt-12 grid gap-x-12 gap-y-6 lg:grid-cols-[188px_1fr]">
          <div className="flex items-start gap-3">
            <span className="mt-[9px] h-px w-3 shrink-0 bg-rack-ember" />
            <h3 className="text-[15px] font-medium leading-snug text-rack-bone/92">不接什么</h3>
          </div>
          <ul className="max-w-[64ch] space-y-2.5">
            {declines.map((d) => (
              <li key={d} className="flex gap-3 text-[13px] leading-[1.9] text-rack-bone/50">
                <span className="mt-[11px] h-px w-2 shrink-0 bg-rack-bone/20" aria-hidden="true" />
                <span>{d}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
